import React from 'react';
import { useSearchParams } from 'react-router-dom';
import StaffScheduling from './StaffScheduling.jsx';
import StaffTimeClock from './StaffTimeClock.jsx';
import './StaffHub.css';

// One "Staff Schedule & Time" hub that replaced the separate Staff Schedule and
// Time Clock nav items — same topic (coach hours), so they share a page with tabs.
// Each tab renders its existing component in `embedded` mode (own page title
// suppressed so the hub owns the heading).
const TABS = [
  { key: 'schedule', label: 'Schedule', icon: '📅' },
  { key: 'timeclock', label: 'Time Clock', icon: '🕐' },
];

function StaffHub({ initialTab = 'schedule' }) {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab') || initialTab;
  const active = TABS.some(t => t.key === requested) ? requested : 'schedule';

  const setTab = (key) => setParams(key === 'schedule' ? {} : { tab: key }, { replace: true });

  return (
    <div className="sh-wrap">
      <div className="sh-head">
        <h1>📅 Staff Schedule &amp; Time</h1>
      </div>

      <div className="sh-tabs" role="tablist">
        {TABS.map(t => (
          <button
            key={t.key}
            role="tab"
            aria-selected={active === t.key}
            className={`sh-tab ${active === t.key ? 'active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            <span className="sh-tab-ico">{t.icon}</span>
            {t.label}
          </button>
        ))}
      </div>

      <div className="sh-panel">
        {active === 'schedule' && <StaffScheduling embedded />}
        {active === 'timeclock' && <StaffTimeClock embedded />}
      </div>
    </div>
  );
}

export default StaffHub;
